/* eslint-disable @stylistic/ts/indent */
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Checkbox, Group, List, Text } from "@mantine/core";
import { get } from "lodash";
import { CampaignQueryDataType } from "src/hooks/campaigns";
import { ReviewDestinationType } from "src/hooks/reviews";

import { CampaignProductCard } from "../../../../CampaignProductCard";
import { FormItem } from "../../../../FormItem";
import { Link } from "../../../../Link";
import { RichTextEditor } from "../../../../RichTextEditor";

export interface AssignmentProductsDetailProps {
    campaign: CampaignQueryDataType;
}

export const AssignmentProductsDetail = ({ campaign }: AssignmentProductsDetailProps) => {
    const { t } = useTranslation(["common"]);

    return (
        <>
            {(campaign?.products || []).map((product, index) => {
                const reviewDestinations = (campaign?.productReviewDestinations || []).find(
                    (item) => item?.productId === product?.id
                );

                return (
                    <CampaignProductCard
                        key={`${index}${product?.id}`}
                        mt={index > 0 ? "lg" : undefined}
                        product={product}
                        bottomSection={
                            <FormItem label={t("campaign_productreviewdestinations")}>
                                {!reviewDestinations?.destinations?.length && <Text color="dimmed">-</Text>}
                                <List>
                                    {(reviewDestinations?.destinations || []).map((destination, index) => {
                                        const config = /^\{.*\}$/.test(destination?.config)
                                            ? JSON.parse(destination.config)
                                            : null;

                                        let content: ReactNode;
                                        switch (destination?.type) {
                                            case ReviewDestinationType.tt:
                                                break;
                                            case ReviewDestinationType.custom:
                                                content = (
                                                    <>
                                                        <Group mb="xs">
                                                            <Checkbox
                                                                color="gray"
                                                                label={t(
                                                                    "campaign_productreviewdestination_custom_confirmsubmission"
                                                                )}
                                                                checked={config?.confirmSubmission || false}
                                                                onChange={() => {}}
                                                            />
                                                            <Checkbox
                                                                color="gray"
                                                                label={t(
                                                                    "campaign_productreviewdestination_custom_requirecontent"
                                                                )}
                                                                checked={config?.requireContent || false}
                                                                onChange={() => {}}
                                                            />
                                                        </Group>
                                                        <FormItem
                                                            label={t(
                                                                "campaign_productreviewdestination_custom_instructions"
                                                            )}
                                                        >
                                                            <RichTextEditor value={config?.instructions} readOnly />
                                                        </FormItem>
                                                    </>
                                                );
                                                break;
                                            default:
                                                content = (
                                                    <>
                                                        {(destination?.configFields || []).map((field, index) => {
                                                            let value: ReactNode = get(config, field.path);

                                                            if (field.type === "url" && value) {
                                                                value = (
                                                                    <Link target="_blank" href={value as string}>
                                                                        {value}
                                                                    </Link>
                                                                );
                                                            }

                                                            return (
                                                                <FormItem
                                                                    key={`${index}${field.path}`}
                                                                    label={field.label}
                                                                >
                                                                    {value || <Text color="dimmed">-</Text>}
                                                                </FormItem>
                                                            );
                                                        })}
                                                    </>
                                                );
                                        }

                                        return (
                                            <List.Item key={`${index}${destination?.type}`}>
                                                {destination?.name}
                                                {content}
                                            </List.Item>
                                        );
                                    })}
                                </List>
                            </FormItem>
                        }
                    />
                );
            })}
        </>
    );
};
